import React, { memo } from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const promises = ['Hablar con frases útiles desde el día 1.', 'Construir vocabulario real (no palabras raras).', 'Entender estructuras de gramática sin memorizar reglas.', 'Mejorar tu lectura con historias cortas.', 'Aprender expresiones naturales con práctica guiada.', 'Mantener constancia con un plan anti-abandono.'];
export function PromiseSection() {
  return <section className="w-full bg-white py-8 md:py-14 px-4" data-id="element-137">
      <div className="max-w-3xl mx-auto" data-id="element-138">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-139">
          Con "Inglés en Acción" vas a:
        </h2>

        <ul className="space-y-3 mb-6" data-id="element-140">
          {promises.map((promise, index) => <li key={index} className="flex items-start gap-3" data-id="element-141">
              <CheckCircleIcon className="w-6 h-6 text-[#22C55E] flex-shrink-0 mt-0.5" data-id="element-142" />
              <span className="text-lg text-[#4A4A5A]" data-id="element-143">{promise}</span>
            </li>)}
        </ul>

        <div className="flex justify-center" data-id="element-144">
          <CTAButton text="SÍ, QUIERO EMPEZAR HOY" data-id="element-145" />
        </div>
      </div>
    </section>;
}